import { render, staticRenderFns } from "./RequestObjectActiveRequests.vue?vue&type=template&id=97f51176&scoped=true&"
import script from "./RequestObjectActiveRequests.vue?vue&type=script&lang=js&"
export * from "./RequestObjectActiveRequests.vue?vue&type=script&lang=js&"
import style0 from "./RequestObjectActiveRequests.vue?vue&type=style&index=0&id=97f51176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f51176",
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd,QBtn,QTooltip,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTh,QTd,QBtn,QTooltip,QItemSection,QItemLabel}, component.options.components || {})
